import { Refresh } from '@browser/Browser';
import { generateName } from '@common/Common';
import CorporateNavigation from '@common/Components/CorporateNavigation.vue';
import { guid } from '@common/Guid';
import { ICommandStatus } from '@cqrs/cqrs';
import { ICommandBase } from '@Quest/cqrs';
import { CreatePortfolioEventPayload, PortfolioCreatorDialogViewModel } from '@Quest/Portfolios/Components/PortfolioCreatorDialog';
import PortfolioCreatorDialog from '@Quest/Portfolios/Components/PortfolioCreatorDialog.vue';
import { CreatePortfolioCommandV1, DeletePortfolioCommandV1, LinkPortfolioCommandV1 } from '@Quest/Portfolios/Domain/commands-core';
import PortfoliosCommands from "@Quest/Portfolios/Domain/commands-vue-component";
import PortfoliosQueries from "@Quest/Portfolios/Domain/queries-vue-component";
import { PortfolioReadModel, PortfoliosPageReadModel, TchProjectReadModel, WorkspaceTchProjectsListReadModel } from '@Quest/Portfolios/Domain/readmodels';
import { Component, mixins } from 'vue-facing-decorator';


@Component({
    components: { CorporateNavigation, PortfolioCreatorDialog },
    watch: {
        portfolioLinkerWorkspaceId: 'onPortfolioLinkerWorkspaceIdChanged'
    }
})
export default class PortfoliosPage extends mixins(PortfoliosQueries, PortfoliosCommands)
{
    get workspaceId(): number { return Number.parseInt(this.$route.params.workspaceId); }
    get strategyId() { return this.$route.params.strategyId; }

    rm: PortfoliosPageReadModel | null = null;
    tchProjects: TchProjectReadModel[] = [];
    portfolioLinker: PortfolioLinkerViewModel = new PortfolioLinkerViewModel();

    portfolioCreatorDialog: PortfolioCreatorDialogViewModel = new PortfolioCreatorDialogViewModel();

    get validPortfolios() { return this.rm!.Portfolios.filter(a => a.IsTchProjectDeleted === false); }
    get invalidPortfolios() { return this.rm!.Portfolios.filter(a => a.IsTchProjectDeleted === true); }
    get portfolioLinkerWorkspaceId(): number { return this.portfolioLinker.workspaceId; }

    //@Watch('portfolioLinker.workspaceId')
    onPortfolioLinkerWorkspaceIdChanged(val: number, oldVal: number)
    {
        this.tchProjects = [];
        this.runLinkeableTchProjectsByWorkspaceIdQueryV1(this.portfolioLinker.workspaceId);
    }


    showPortfolioLinker()
    {
        this.portfolioLinker.portfolioId = guid();
        this.portfolioLinker.opened = true;
    }

    closePortfolioLinker()
    {
        this.portfolioLinker.opened = false;
    }


    showPortfolioCreator()
    {
        this.portfolioCreatorDialog.show(this.workspaceId, generateName("Portfolio"), this.rm.Workspaces);
    }


    handleDeletePortfolioCommand(p: PortfolioReadModel)
    {
        if (confirm("Are you sure?") == true)
        {
            this.invokeDeletePortfolioCommandV1(this.workspaceId, p.Id);
        }
    }

    handleCreatePortfolioCommand(payload: CreatePortfolioEventPayload)
    {
        this.invokeCreatePortfolioCommandV1(this.workspaceId, payload.portfolioWorkspaceId, this.strategyId, guid(), payload.portfolioName, payload.portfolioDescription);
    }

    handleLinkPortfolioCommand()
    {
        this.invokeLinkPortfolioCommandV1(this.workspaceId, this.strategyId, this.portfolioLinker.portfolioId!, this.portfolioLinker.workspaceId!, this.portfolioLinker.tchProjectId!);
    }


    mounted()
    {
        document.title = "Portfolios | TransparentChoice";
        this.runPortfoliosPageQueryV1(this.workspaceId, this.strategyId);
    }

    onSetModel(model: any, modelName: string) 
    {
        if (modelName == "PortfoliosPageReadModel")
        {
            this.rm = model as PortfoliosPageReadModel;

        }
        else if (modelName == "WorkspaceTchProjectsListReadModel")
        {
            const rm = model as WorkspaceTchProjectsListReadModel;
            this.tchProjects = rm.Projects;
        }
    }

    onCommandSucceed(cmd: ICommandBase, correlationId: string)
    {
        if (CreatePortfolioCommandV1.matchType(cmd))
        {
            this.portfolioCreatorDialog.close();
            Refresh();
        }
        else if (LinkPortfolioCommandV1.matchType(cmd))
        {
            this.closePortfolioLinker();
            Refresh();
        }
        else if (DeletePortfolioCommandV1.matchType(cmd))
        {
            Refresh();
        }
    }

    onCommandFailed(status: ICommandStatus)
    {
        if (CreatePortfolioCommandV1.matchType(status.Command))
        {
            this.portfolioCreatorDialog.displayValidationErrors(status.ValidationErrors!);
        }
    }
}

class PortfolioLinkerViewModel
{
    opened: boolean = false;

    portfolioId: string | null = null;
    workspaceId: number | null = null;
    tchProjectId: number | null = null;

    get canSave() { return this.workspaceId && this.tchProjectId; }

    close()
    {
        this.opened = false;
    }
}